import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"overflow":"hidden"}},[_c('runnit-carousel',{attrs:{"items":_vm.items,"gap":"0"},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c(VBtn,{attrs:{"text":"","color":_vm.value === item.id ? 'primary' : 'auto'},on:{"click":function($event){return _vm.handleTabChange(item.id)}}},[_c(VIcon,{staticClass:"mr-2"},[_vm._v(" "+_vm._s(item.icon)+" ")]),_vm._v(" "+_vm._s(item.label)+" ")],1)]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }